import { Frequency } from '@amzn/taskscheduling-service';
import { FrequencyOption } from 'src/common/constants/frequency';

export const determineFrequency = (name: string): FrequencyOption | null => {
  const taskName = name.toUpperCase();
  if (taskName.includes(Frequency.DAILY)) {
    return Frequency.DAILY;
  }
  if (taskName.includes(Frequency.MONTHLY)) {
    return Frequency.MONTHLY;
  }
  return null;
};

export const handleEnableDatasetDateChange = (
  checked: boolean,
  setEnableDatasetDate: (value: boolean) => void,
  setDatasetDate: (value: string) => void,
) => {
  setEnableDatasetDate(checked);
  if (!checked) {
    setDatasetDate('');
  }
};
